module.exports = __webpack_public_path__ + "img/saintkittsandnevis.a3f04db9.svg";